import { Component, Inject, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { itineraryReselector, programsArray } from 'src/app/store/reselectors/programs.reselector';
import { CommonModule, formatDate } from '@angular/common';
import { LabelMakerDialogComponent, LabelMakerData, LabelUpdateFunctionParams } from '../label-marker/label-maker.dialog.component';
import { selectedEventLabels } from 'src/app/store/reselectors/accounts.reselector';
import { JoiEvent, Label } from 'globals/store/events.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from '../wrapper.component';
import { ViewEventData } from 'src/app/services/event.view.service';
import { accountListSelector } from './../../store/reselectors/accounts.reselector';
import { Itinerary } from 'globals/store/programs.data';
import { MatButtonModule } from '@angular/material/button';
import { PhotoComponent } from '../photo';
import { IconComponent } from '../icon/icon.component';
import { LabelItemComponent } from '../label-marker/label-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { programsActions } from 'src/app/store/programs.era';
import { Account } from 'globals/store/accounts.data';

@Component({
    selector: 'view-event-dialog',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*', 'padding-bottom': '10px' })),
            state('collapse, undefined, void', style({ height: '0', 'padding-bottom': '0' })),
            transition('* => *', [animate('600ms')]),
            transition('void => *', [animate('0ms')]),
            transition('undefined => *', [animate('0ms')])
        ])
    ],
    template: `
<div class="eventInfo_dialog joi-dialog" *ngIf="!!event">
    <icon class="more" *ngIf="!data.viewFromEvent" [matMenuTriggerFor]="eventOptions" matIcon='more_vert'></icon>
    <mat-menu #eventOptions="matMenu" xPosition="before">
      <button mat-menu-item (click)="dialogRef.close('join')"       *ngIf="!event.closed && !event.can_access && account?.is_manager">Join workforce</button>
      <button mat-menu-item (click)="dialogRef.close('edit_title')" *ngIf="!event.closed && event.can_access && account?.is_manager">Edit event name</button>
      <button mat-menu-item (click)="dialogRef.close('view')">View</button>
      <button mat-menu-item (click)="dialogRef.close('duplicate')"  *ngIf="!event.closed && event.can_access && account?.is_manager">Duplicate event</button>
      <button mat-menu-item (click)="dialogRef.close('change')"     *ngIf="canChangeEventAccount && !event.closed && event.can_access && account?.is_manager">Change event account</button>
      <button mat-menu-item (click)="dialogRef.close('close')"      *ngIf="!event.closed && event.can_access && account?.is_manager">Close event</button>
      <button mat-menu-item (click)="dialogRef.close('delete')"     *ngIf="account?.is_manager && event.can_access">Delete event</button>
    </mat-menu>
    <div mat-dialog-content>
        <div class="title2">{{event.title}}</div>
        <div class="labels" (click)="addLabel($event)" *ngIf="account?.users">
            <div class="lbl" *ngFor="let id of event.labels">
                <label-item *ngIf="labels && labels[id] as lbl" [color]="lbl.color" [label]="lbl.label"></label-item>
            </div>
            <div class="caption" *ngIf="!event.labels || event.labels.length === 0">No event labels</div>&nbsp;
            <div class="plus_label" *ngIf="!event.closed && !event.is_readonly">+</div>
        </div>
        <div class="dates"><span *ngFor="let date_part of event.dates_string">{{date_part}}&nbsp;</span></div>
        <div class="until" *ngIf="data.daysUntil.indexOf('day')>0">{{data.daysUntil + ' until event'}}</div>
        <div class="close" *ngIf="event.closed">Event closed</div>
        <div class="itinerary_info">
            <div class="event_date" (click)="showItinerary=(showItinerary=='expand'?'collapse':'expand')">
                <icon [matIcon]="(showItinerary=='expand' ? 'arrow_drop_down' : 'arrow_right')"></icon>
                <div>Event Summary</div>
            </div>
            <div class="itinerary_panel" [@drop]="showItinerary">
                <div class="itinerary" *ngFor="let it of itinerary; index as idx; last as last"
                        [ngClass]="{narrow: last || programService.dateID(itinerary[idx].date) == programService.dateID(itinerary[idx+1].date)}">
                    <b>{{idx == 0 || programService.dateID(itinerary[idx].date) != programService.dateID(itinerary[idx-1].date) ? (it.date | date:'EEEE d MMMM y'): '&nbsp;'}}</b>
                    <div class="contents">
                    <span class="time">{{it.time}}</span>
                    <div class="venue">
                        <div><b>{{it.title}}</b></div>
                        <div>{{it.location}}{{it.location && it.venue ? ', ':''}}{{it.venue}}</div>
                        <div class="address">{{it.address}}</div>
                        <div class="address p1" *ngIf="it.expectedNumber">Expected numbers: {{it.expectedNumber}}</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info">
            <h5>Event owner</h5>
            <div class="row">
                <photo [data]="event.event_owner"></photo>
                <div class="name" *ngIf="event.event_owner && event.event_owner.firstName">
                    {{ event.event_owner.firstName + ' ' + event.event_owner.lastName }}
                </div>
            </div>
        </div>
        <div class="info">
            <h5>ACCOUNT</h5>
            <div class="row">
                <photo [data]="account"></photo>
                <div class="name" [title]="account?.title" [ngClass]="{info_loading:!account?.title}">{{account?.title}}</div>
            </div>
        </div>
    </div>
    <div class="mat-dialog-actions" >
        <button mat-button (click)="dialogRef.close()">Done</button>
        <button mat-button color="primary" *ngIf="!data.viewFromEvent" (click)="checkClose($event)">View Event</button>
    </div>
</div>

    `,
    styleUrls: ['dialog.viewEvent.scss'],
    standalone: true,
    imports: [MatButtonModule, PhotoComponent, IconComponent, CommonModule, LabelItemComponent, MatMenuModule],
})
export class ViewEventDialogComponent extends Wrapper<ViewEventDialogComponent> implements OnInit {

  event: JoiEvent
  account!: Partial<Account>
  labels!: Dictionary<Label>
  labelTemplate: Array<Label> = [];
  itinerary: Itinerary[] = [];
  showItinerary = 'collapse';
  canChangeEventAccount = false

  constructor(
    public dialogRef: MatDialogRef<ViewEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewEventData,
  ) {
    super()
    const { event, viewFromEvent } = this.data
    this.event = event;
    console.log({ event, viewFromEvent })

    if (viewFromEvent) this.subProp(this.store.select('events', 'event'), 'event')
    else this.subProp(this.store.select('events', 'entities', this.data.event.eventId), 'event')

    if (event.accountId && !viewFromEvent) {
      this.accountService.getEventAccount(event.accountId);
      this.store.dispatch(programsActions.clearPrograms()) // clear old programs first
      this.programService.getPrograms(event.eventId);
    }
    this.subProp(this.store.select(itineraryReselector), 'itinerary')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.selectCallback(accountListSelector, null, (accountsList: Account[]) => this.canChangeEventAccount = accountsList.length > 1)
    this.selectCallback(selectedEventLabels, null, (labels: { accountEventLabelsList: Label[], accountEventLabelsById: Dictionary<Label> }) => {
      this.labels = labels.accountEventLabelsById
      this.labelTemplate = labels.accountEventLabelsList
    })
  }

  ngOnInit() { }

  checkClose(event: KeyboardEvent | PointerEvent) {
    if (event.shiftKey || event.ctrlKey || event.metaKey) return
    this.router.navigate(['/event/build/', this.event.eventId])
    this.dialogRef.close()
  }

  async promptDelete(evt: MouseEvent) {
    const rect = (evt.target as HTMLElement).getBoundingClientRect();
    const data: ConfirmDeleteData = { rect, title: 'Delete this event', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dialogRef.close('delete')
  }

  labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      // TO DO: DISPATCH THROUGH STORE?
      this.eventService.updateEvent(this.event.eventId, { labels })
    }
    if (labelsChanged) {
      this.accountService.updateAccount(
        this.event.accountId,
        { labels: labelTemplate },
        { file: 'event-view.component.ts', function: 'labelUpdateFunction', error: new Error(), message: 'There was an error adding this label' })
    }
  }

  addLabel(evt: MouseEvent) {
    if (this.event.is_readonly) return
    let parent = (evt.target as HTMLElement).parentElement as HTMLElement;
    while (parent.classList && !parent.classList.contains('labels')) {
      if (parent.classList.contains('mat-dialog-content')) {
        parent = parent.querySelector('.labels') as HTMLElement;
      } else {
        parent = parent.parentElement as HTMLElement;
      }
    }
    const labelsRect = parent.getBoundingClientRect();
    const data: LabelMakerData = {
      labels: this.event.labels || [],
      type: 'event',
      position: { top: labelsRect.bottom - 20, left: labelsRect.left },
      labelUpdateFunction: this.labelUpdateFunction.bind(this),
      labelTemplate: this.labelTemplate,
    }
    this.dialog.open(LabelMakerDialogComponent, {
      minWidth: '300px',
      backdropClass: 'backdrop',
      panelClass: ['label-panel', 'centered'],
      maxHeight: '100%',
      data
    })
  }
}